import type { Appearance } from '@clerk/types';

const ink = '#07080c';
const paper = '#f4f4f5';
const muted = '#a1a1aa';
const yellow = '#f5c518';
const blue = '#3ee0ff';
const card = '#111113';
const line = 'rgba(255,255,255,0.10)';

export const clerkAppearance: Appearance = {
  variables: {
    colorPrimary: yellow,
    colorBackground: card,
    colorText: paper,
    colorTextSecondary: muted,
    colorTextOnPrimaryBackground: ink,
    colorNeutral: '#3f3f46',
    colorInputBackground: '#18181b',
    colorInputText: paper,
    colorDanger: '#fb7185',
    colorSuccess: '#3dff9a',
    colorWarning: yellow,
    borderRadius: '0.9rem',
    fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
    fontFamilyButtons: 'Inter, ui-sans-serif, system-ui, sans-serif',
  },
  layout: {
    logoImageUrl: '/images/Fantasy Fiesta Logo - Transparent.png',
    logoPlacement: 'inside',
    socialButtonsVariant: 'blockButton',
    socialButtonsPlacement: 'top',
    showOptionalFields: false,
  },
  elements: {
    logoImage: 'h-10 w-auto',
    headerTitle: 'font-semibold text-zinc-50',
    headerSubtitle: 'text-zinc-400',
    card: 'border border-white/10 bg-[#111113] shadow-2xl',
    modalContent: 'bg-[#07080c]',
    modalCloseButton: 'text-zinc-400 hover:text-white',
    socialButtonsBlockButton:
      'border border-white/10 bg-white/5 text-zinc-100 hover:bg-white/10',
    socialButtonsBlockButtonText: 'text-zinc-100',
    formFieldLabel: 'text-zinc-300',
    formFieldInput:
      'border border-white/10 bg-[#18181b] text-zinc-50 placeholder:text-zinc-500',
    formButtonPrimary:
      'bg-[#f5c518] text-[#07080c] hover:bg-[#ffd84a] shadow-none',
    footerActionLink: 'text-[#3ee0ff] hover:text-[#7aecff]',
    identityPreview: 'border border-white/10 bg-white/5',
    badge: 'bg-[#f5c518]/15 text-[#f5c518]',
    userButtonPopoverCard: 'border border-white/10 bg-[#111113] shadow-2xl',
    userButtonPopoverMain: 'bg-[#111113]',
    userButtonPopoverActionButton: 'text-zinc-100 hover:bg-white/5',
    userButtonPopoverActionButtonText: 'text-zinc-100',
    userButtonPopoverActionButtonIcon: 'text-zinc-300',
    userButtonPopoverCustomItemButton: 'text-zinc-100 hover:bg-white/5',
    userButtonPopoverFooter: 'border-t border-white/10 bg-[#0b0b0e]',
    userPreviewMainIdentifier: 'text-zinc-50',
    userPreviewSecondaryIdentifier: 'text-zinc-400',
    userButtonAvatarBox: `border border-[${blue}]/30`,
    navbar: 'bg-[#111113]',
    navbarButton: 'text-zinc-300',
    profileSectionTitleText: 'text-zinc-100',
    accordionTriggerButton: 'text-zinc-100',
  },
};

export { ink, paper, muted, yellow, blue, card, line };
